const asideMovil = document.querySelector(".movil-menu");
if (asideMovil) {
  const selectors = {
    contentMovil: document.querySelector(".movil-menu__content"),
    topMenu: document.querySelector(".header__menu"),
    midMenu: document.querySelector(".mid-bar"),
    utils: document.querySelector(".top-bar__interesting"),
    togleMenu: document.querySelector(".icon-menu"),
    checkboxMenu: document.querySelector("#check-icon"),
  };

  const moveContents = () => {
    if (
      selectors.topMenu &&
      !selectors.contentMovil.contains(selectors.topMenu)
    ) {
      selectors.contentMovil.appendChild(selectors.topMenu);
    }
    if (
      selectors.midMenu &&
      !selectors.contentMovil.contains(selectors.midMenu)
    ) {
      selectors.contentMovil.appendChild(selectors.midMenu);
    }
    if (selectors.utils && !selectors.contentMovil.contains(selectors.utils)) {
      selectors.contentMovil.appendChild(selectors.utils);
    }
  };

  // Función para bloquear/desbloquear el scroll del body
  const toggleBodyScroll = (isMenuOpen) => {
    if (isMenuOpen) {
      // Bloquear scroll del body
      document.body.style.overflow = 'hidden';
      document.body.classList.add('menu-open');
    } else {
      // Restaurar scroll del body
      document.body.style.overflow = '';
      document.body.classList.remove('menu-open');
    }
  };

  // Función para sincronizar el checkbox con el estado del menú
  const syncCheckbox = (isOpen) => {
    if (selectors.checkboxMenu) {
      selectors.checkboxMenu.checked = isOpen;
    }
  };

  if (selectors.togleMenu) {
    selectors.togleMenu.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const isCurrentlyOpen = asideMovil.classList.contains("isOpen");
      
      asideMovil.classList.toggle("isOpen");
      moveContents();
      
      // Controlar el scroll del body según el estado del menú
      const newState = !isCurrentlyOpen;
      toggleBodyScroll(newState);
      syncCheckbox(newState);
    });
  }

  // Cerrar menú al hacer clic fuera de él (con un pequeño delay para evitar conflictos)
  document.addEventListener('click', (e) => {
    setTimeout(() => {
      if (asideMovil.classList.contains('isOpen') && 
          !asideMovil.contains(e.target) && 
          !selectors.togleMenu.contains(e.target)) {
        asideMovil.classList.remove('isOpen');
        toggleBodyScroll(false);
        syncCheckbox(false);
      }
    }, 10);
  });

  // Cerrar menú al presionar Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && asideMovil.classList.contains('isOpen')) {
      asideMovil.classList.remove('isOpen');
      toggleBodyScroll(false);
      syncCheckbox(false);
    }
  });

  // Restaurar scroll al redimensionar ventana (para desktop)
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1024 && asideMovil.classList.contains('isOpen')) {
      asideMovil.classList.remove('isOpen');
      toggleBodyScroll(false);
      syncCheckbox(false);
    }
  });
}
